var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"flyerImage",staticClass:"flyerImage first",style:({
    'background-image': 'url(' + _vm.url + ')',
    'background-position': _vm.cPosX + 'px ' + _vm.value.posY + 'px',
    'background-size': _vm.scale + '% '
  })})}
var staticRenderFns = []

export { render, staticRenderFns }